/* Tha Layover — premium cart drawer controller */
(function () {
  'use strict';
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var removeLabel = root.getAttribute('data-remove-label') || 'Remove';
  var poKey = root.getAttribute('data-po-key') || 'Pre-order';
  var itemsEl = root.querySelector('[data-cd-items]');
  var totalEl = root.querySelector('[data-cd-total]');
  var checkoutEl = root.querySelector('[data-cd-checkout]');
  var panel = root.querySelector('.tl-cd-panel');
  var lastFocus = null, discountCode = '', justAdded = null;

  function formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, parts[0].replace(/,/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/g, parts.join('.'));
  }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  function setCount(n) {
    document.querySelectorAll('[data-cd-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('.tl-count').forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; });
  }

  function render(cart) {
    var empty = !cart || !cart.item_count;
    root.setAttribute('data-empty', empty ? 'true' : 'false');
    setCount(cart ? cart.item_count : 0);
    if (empty) { itemsEl.innerHTML = ''; return; }
    totalEl.textContent = formatMoney(cart.total_price);
    updateCheckout();
    itemsEl.innerHTML = cart.items.map(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.name) + ' · ' + esc(o.value); }).join(' &nbsp;/&nbsp; ');
      var isNew = justAdded && String(it.variant_id) === String(justAdded);
      var props = it.properties || {}, po = '', extra = '';
      Object.keys(props).forEach(function (k) {
        if (k.charAt(0) === '_' || props[k] === '' || props[k] == null) return;
        if (k === poKey) po = String(props[k]);
        else extra += '<p class="tl-cd-variant">' + esc(k) + ' · ' + esc(props[k]) + '</p>';
      });
      return '<div class="tl-cd-line' + (isNew ? ' is-new' : '') + '" style="--i:' + i + '" data-line="' + (i + 1) + '" data-qty-val="' + it.quantity + '">' +
        '<a class="tl-cd-media" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
          (it.image ? '<img class="tl-cd-thumb" src="' + esc(sized(it.image, 240)) + '" alt="" width="96" height="128" loading="lazy">' : '<span class="tl-cd-thumb"></span>') +
        '</a>' +
        '<div class="tl-cd-info">' +
          '<div class="tl-cd-top"><a class="tl-cd-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          '<span class="tl-cd-price">' + formatMoney(it.final_line_price) + '</span></div>' +
          (opts ? '<p class="tl-cd-variant">' + opts + '</p>' : '') + extra +
          (po ? '<p class="tl-cd-po"><span class="tl-po-tag">' + esc(poKey) + '</span>' + (po !== poKey ? '<span class="tl-cd-po-msg">' + esc(po) + '</span>' : '') + '</p>' : '') +
          '<div class="tl-cd-actions">' +
            '<div class="tl-cd-qty"><button type="button" data-step="-1" aria-label="Decrease quantity of ' + esc(it.product_title) + '">−</button>' +
            '<span aria-label="Quantity">' + it.quantity + '</span>' +
            '<button type="button" data-step="1" aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button></div>' +
            '<button type="button" class="tl-cd-remove" data-remove>' + esc(removeLabel) + '</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
    justAdded = null;
  }

  function updateCheckout() {
    if (checkoutEl) checkoutEl.setAttribute('href', discountCode ? '/checkout?discount=' + encodeURIComponent(discountCode) : '/checkout');
  }
  function setBusy(b) { panel.classList.toggle('is-busy', b); }
  function json(r) { if (!r.ok) throw r; return r.json(); }
  function refresh() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(json).then(render); }

  function change(line, qty) {
    setBusy(true);
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty }) })
      .then(json).then(render).catch(function () {}).then(function () { setBusy(false); });
  }

  function addBody(body, isForm, variantId) {
    setBusy(true);
    var opts = { method: 'POST', headers: { Accept: 'application/json' }, body: body };
    if (!isForm) opts.headers['Content-Type'] = 'application/json';
    return fetch('/cart/add.js', opts).then(json)
      .then(function (res) { justAdded = variantId || (res && (res.variant_id || (res.items && res.items[0] && res.items[0].variant_id))); return refresh(); })
      .then(function () { open(); })
      .catch(function () { refresh(); open(); })
      .then(function () { setBusy(false); });
  }
  function add(variantId, quantity, properties) {
    var item = { id: variantId, quantity: quantity || 1 };
    if (properties) item.properties = properties;
    return addBody(JSON.stringify(item), false, variantId);
  }

  function open() {
    if (root.getAttribute('aria-hidden') === 'false') return;
    lastFocus = document.activeElement;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tl-cd-open');
    setTimeout(function () { var c = root.querySelector('.tl-cd-close'); if (c) c.focus({ preventScroll: true }); }, 80);
  }
  function close() {
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tl-cd-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function closeChoosing(except) {
    document.querySelectorAll('.tl-catalog-card.is-choosing').forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-choosing');
      var b = c.querySelector('[data-card-choose]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  /* drawer interactions */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]') || e.target.closest('[data-cd-overlay]')) { close(); return; }
    var step = e.target.closest('[data-step]');
    var rm = e.target.closest('[data-remove]');
    var lineEl = (step || rm) && (step || rm).closest('[data-line]');
    if (!lineEl) return;
    var line = parseInt(lineEl.getAttribute('data-line'), 10);
    var cur = parseInt(lineEl.getAttribute('data-qty-val'), 10) || 1;
    change(line, rm ? 0 : Math.max(0, cur + parseInt(step.getAttribute('data-step'), 10)));
  });

  var applyBtn = root.querySelector('[data-cd-discount-apply]');
  if (applyBtn) applyBtn.addEventListener('click', function () {
    var input = root.querySelector('[data-cd-discount]');
    var msg = root.querySelector('.tl-cd-disc-msg');
    discountCode = (input.value || '').trim();
    if (discountCode) { msg.textContent = '“' + discountCode + '” will be applied at checkout.'; msg.setAttribute('data-on', ''); }
    else msg.removeAttribute('data-on');
    updateCheckout();
  });

  /* focus trap + escape */
  document.addEventListener('keydown', function (e) {
    if (root.getAttribute('aria-hidden') === 'false') {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = panel.querySelectorAll('a[href],button:not([disabled]),input,summary');
        f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    } else if (e.key === 'Escape') closeChoosing();
  });

  /* global triggers */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); refresh().catch(function () {}); open(); return; }

    var choose = e.target.closest('[data-card-choose]');
    if (choose) {
      var card = choose.closest('[data-catalog-card]');
      var on = !card.classList.contains('is-choosing');
      closeChoosing(card);
      card.classList.toggle('is-choosing', on);
      choose.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var first = card.querySelector('.tl-card-size:not([disabled])'); if (first) first.focus({ preventScroll: true }); }
      return;
    }

    var addBtn = e.target.closest('[data-add-variant]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      addBtn.classList.add('is-loading');
      var poMsg = addBtn.getAttribute('data-po'), poProps = null;
      if (poMsg !== null) { poProps = {}; poProps[poKey] = poMsg; }
      add(addBtn.getAttribute('data-add-variant'), 1, poProps).then(function () {
        addBtn.classList.remove('is-loading');
        closeChoosing();
      });
      return;
    }
    if (!e.target.closest('.tl-catalog-card')) closeChoosing();
  });

  /* native product forms (PDP) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var fd = new FormData(form);
    addBody(fd, true, fd.get('id'));
  });

  window.TLCart = { open: open, close: close, add: add, refresh: refresh };
  if (root.getAttribute('data-empty') === 'false') refresh().catch(function () {});
})();
